export const updateDate = (dateString: string) => {
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthName = monthNames[dateObj.getMonth()];

    return {
        formattedDate: `${hours}:${minutes}:${seconds}  ${day}-${monthName}`,
        date: `${year}-${month}-${day}`,
        time: `${hours}:${minutes}`
    };
};
export interface Template {
    title: string;
    colors: Colors;
    fonts: Fonts;
    texts: Texts;
    images: Record<string, any>;
}

interface Colors {
    mainBgColor: string;
    blockBgColor: string;
    fontColor: string;
    buttonFontColor: string;
    blockTitleBgColor: string;
    fontTitleColor: string;
    buttonBGColor: string;
    fieldsFontColor: string;
    fieldsBgColor: string;
}

interface Fonts {
    mainFontSize: string;
    titleFontSize: string;
    buttonFontSize: string;
    fieldsFontSize: string;
    fontFamily: string;
    titleFontFamily: string;
}

interface Texts {
    block1Title: string;
    block2Title: string;
    block3Title: string;
    block4Title: string;
    block5Title: string;
    block6Title: string;
    siteName: string;
    title: string;
    description: string;
}

export interface ticketHistoryInterface {
    approved:boolean;
    atag: string;
    code: string;
    created: string
    currency: string
    events: any[]
    ext: number
    ext_amount: number
    ext_type: string
    gross_payout: number
    id: string
    net_payout: number
    odds: number
    price: number
    result: string
    source: string
    stake: number
    status: number
    type: string
    updated: string
    user_id: string
    wht: number
    operator_time_created?: string
    wht_amount: number
}

export const listOfBank = [
    'Amro',
    'BNP',
    'Commerzbank',
    'Danske_Bank',
    'Deutsche_Bank',
    'Handelsbanken',
    'ING',
    'N26',
    'Nordea',
    'Postbank',
    'Rabobank',
    'Revolut',
    'SEB',
    'Sparkasse',
    'Volksbank'
]